<template>
  <div>
    <div class="test" v-if="component_done_loading">
      <template v-if="test._isPreview">
        <test-topbar
          :testObj="test"
          @timer-shown="processTimerShown"
          :options="{ forceHideTimer: true }"
          ref="topbarRef"
        ></test-topbar>
      </template>
      <template v-else>
        <test-topbar
          :testObj="test"
          @timer-shown="processTimerShown"
          ref="topbarRef"
        ></test-topbar>
      </template>

      <div
        :style="{ paddingTop: computedPaddingTop, paddingBottom: '36px' }"
        class="test_content"
      >
        <h1 class="print">{{ test.name }}</h1>
        <stopping-div
          :testObj="test"
          @display="processDisplayTestProper"
          class="padding20"
        ></stopping-div>
        <div v-if="display_test_proper" class="new-side-bar">
          <template v-if="!test._isPreview || test._isTeacherPreview">
            <test-sidebar
              :testObj="test"
              @button-clicked="handleButtonClicked"
              :sideBarClosedValue="sideBarClosed"
              ref="sideBarRef"
            ></test-sidebar>
          </template>
          <main
            class="main padding20"
            :style="{
              marginLeft: computedMarginLeft,
              width: 'calc(100% - ' + computedMarginLeft + ')',
            }"
          >
            <template v-if="!test._isPreview || test._isTeacherPreview">
              <team-leadership
                class="marginBottom20"
                v-if="
                  (test.type == 'trat' ||
                    (test.type == 'application' &&
                      test.others.applicationType == 'team')) &&
                    !test._isPreview
                "
                :testObj="test"
              ></team-leadership>

              <div :class="{ 'flexSpaceBetween align-items': notMobile }">
                <test-progression
                  class="width100"
                  :testObj="test"
                ></test-progression>

                <question-pagination-container
                  v-if="notMobile"
                  class="marginLeft20 flexRight"
                  :testObj="test"
                  :options="{
                    showPagination: false,
                  }"
                ></question-pagination-container>
              </div>
            </template>
            <div>
              <question-pagination-container
                v-if="!notMobile"
                class="flexRight marginTop20"
                :testObj="test"
                :options="{
                  showPagination: false,
                }"
              ></question-pagination-container>
              <question-groups
                class="marginTop20"
                :testObj="test"
                :fetchTest="fetchTest"
              ></question-groups>
              <question-pagination-container
                class="marginTop20"
                :testObj="test"
              ></question-pagination-container>
            </div>
          </main>
        </div>

        <!-- <div class="col-md-10 col-md-offset-1 flex" v-if="display_test_proper">
          <div
            class="col-xs-12 marginBottom10"
            v-if="!test._isPreview || test._isTeacherPreview"
          >
            <team-leadership
              class="marginBottom20"
              v-if="
                (test.type == 'trat' ||
                  (test.type == 'application' &&
                    test.others.applicationType == 'team')) &&
                  !test._isPreview
              "
              :testObj="test"
            ></team-leadership>
            <test-progression :testObj="test"></test-progression>
          </div>
          <div
            class="col-xs-12 col-md-8 col-md-offset-4 marginBottom20"
            :class="{
              '':
                (test.type == 'trat' ||
                  (test.type == 'application' &&
                    test.others.applicationType == 'team')) &&
                !test._isPreview,
            }"
          >
            <question-pagination-container
              class="marginTop20"
              :testObj="test"
            ></question-pagination-container>
          </div>
          <div
            class="col-md-4"
            v-if="!test._isPreview || test._isTeacherPreview"
          >
            <test-sidebar :testObj="test"></test-sidebar>
          </div>
          <div
            class="col-xs-12 col-md-8 testPanel"
            :class="{
              '':
                (test.type == 'trat' ||
                  (test.type == 'application' &&
                    test.others.applicationType == 'team')) &&
                !test._isPreview,
            }"
          >
            <question-groups
              :testObj="test"
              :fetchTest="fetchTest"
            ></question-groups>
            <question-pagination-container
              class="marginTop20"
              :testObj="test"
              :options="{ reverse: true }"
            ></question-pagination-container>
          </div>
        </div> -->
      </div>
      <!-- <div
        id="test_confirm_modal"
        class="modal"
        style="z-index: 50001 !important"
        v-shortkey.propagte="{
          left: ['arrowleft'],
          right: ['arrowright'],
          enter: ['enter'],
        }"
        @shortkey="submitConfirmAccessibility"
        tabindex="-1"
        role="dialog"
        aria-labelledby="testConfirmModal-title"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                &times;
              </button>
              <h4 id="testConfirmModal-title" class="modal-title">
                Test Submission
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="message">
                  <div
                    class="col-xs-12"
                    v-if="test.type == 'irat' || test.type == 'trat'"
                  >
                    <div class="col-xs-offset-1 col-xs-10">
                      <div class="col-xs-12 marginBottom15">
                        <i class="fa fa-exclamation-triangle"></i>
                      </div>
                      <div class="col-xs-12 marginBottom30">
                        Please note that once you have submitted, you cannot
                        make changes to your answer choices. Are you sure about
                        this?
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12" v-if="test.type == 'application'">
                    <div class="col-xs-offset-1 col-xs-10">
                      <div class="col-xs-12 marginBottom15">
                        <i class="fa fa-exclamation-triangle"></i>
                      </div>
                      <div class="col-xs-12 marginBottom30">
                        Great! You have completed your Application Test and
                        ready for submission. You are about to submit your test.
                        No changes can be made after submission. Are you sure to
                        go ahead?
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 buttonGroup">
                  <button
                    class="btn btn-success mainBtn"
                    @click.prevent="submitTest()"
                    aria-label="Submit Test"
                  >
                    <i class="fas fa-check"></i>&nbsp;Submit Test
                  </button>
                  <button
                    class="btn btn-default mainBtn"
                    data-dismiss="modal"
                    aria-label="Back"
                  >
                    <i class="fas fa-caret-left"></i>&nbsp;Back
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div> -->
    </div>
    <div
      class="modal"
      id="previewChooseTestTypeModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="previewChooseTestTypeModal-title"
    >
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="preview modal-content">
          <div class="modal-header">
            <h4 id="previewChooseTestTypeModal-title" class="modal-title">
              Test Preview
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xs-12" style="text-align: center">
                <div>You are previewing an <b>IRAT AND TRAT</b> Activity.</div>
                <div>Please choose what test type you want to preview.</div>
              </div>
            </div>
            <div class="row">
              <div class="flex">
                <div class="col-xs-12 col-md-6">
                  <button
                    id="modal-irat-btn"
                    class="btn btn-default mainBtn"
                    style="width: 100%"
                    @click.prevent="processPreviewTestType('irat')"
                    data-dismiss="modal"
                    aria-label="Preview IRAT"
                  >
                    IRAT
                  </button>
                </div>
                <div class="col-xs-12 col-md-6">
                  <button
                    id="modal-trat-btn"
                    class="btn btn-default mainBtn"
                    style="width: 100%"
                    @click.prevent="processPreviewTestType('trat')"
                    data-dismiss="modal"
                    aria-label="Preview TRAT"
                  >
                    TRAT
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="clearAnswersModal"
      class="modal clearAnswersModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="clearAnswersModal-title"
    >
      <div class="modal-dialog">
        <div class="preview modal-content">
          <div class="modal-header">
            <h4 id="clearAnswersModal-title" class="modal-title">
              Attention
            </h4>
          </div>
          <div class="modal-body">
            <div class="textAlignCenter">
              <p style="font-size: 22px">
                Your instructor has reset your answers
              </p>
            </div>
            <div class="flex marginTop20">
              <div class="center-block">
                <button class="btn btn-primary subBtn" data-dismiss="modal ">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="teacherEndedModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content blue-modal-new">
          <div class="modal-body textAlignCenter">
            <img
              src="/img/teacher_ended.png"
              alt="Instructor Has End The Test"
              class="marginBottom20"
              width="50%"
            />

            <p class="marginBottom5">
              <b>Your instructor has ended the activity.</b>
            </p>

            <p class="marginBottom30">Please wait.</p>

            <div class="flexOnly justifyCenter">
              <p class="loadingAnimation">Redirecting</p>
              <div class="modal-countdown-number marginLeft10"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="timeUpModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content blue-modal-new">
          <div class="modal-body textAlignCenter">
            <img
              src="/img/time_up.png"
              alt="Time up"
              class="marginBottom20"
              width="50%"
            />

            <p class="marginBottom5"><b>Time’s Up!</b></p>

            <p class="marginBottom30">Please wait.</p>

            <div class="flexOnly justifyCenter">
              <p class="loadingAnimation">Redirecting</p>
              <div class="modal-countdown-number marginLeft10"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="test_confirm_modal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content blue-modal-new">
          <div class="modal-body textAlignCenter">
            <img
              src="/img/submit_alert.png"
              alt="Submit Alert"
              class="marginBottom20"
              width="30%"
            />

            <p class="marginBottom5">
              You will not be able to change your answers after submitting. This
              is <b>final.</b>
            </p>

            <p class="marginBottom30">Do you want to submit?</p>

            <div class="flex marginTop30">
              <button
                class="btn btn-default mainBtn"
                data-dismiss="modal"
                aria-label="Cancel"
              >
                Cancel
              </button>
              <button
                class="btn btn-success mainBtn"
                aria-label="Submit Test"
                data-dismiss="modal"
                @click.prevent="submitTest()"
              >
                Submit Test
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="redirectingModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content blue-modal-new">
          <div class="modal-body textAlignCenter">
            <img
              src="/img/redirecting.png"
              alt="redirecting"
              class="marginBottom20"
              width="30%"
            />
            <h3 class="text-success">Submission Successful</h3>
            <div class="flexOnly justifyCenter marginBottom10">
              <p class="loadingAnimation">Redirecting in</p>
              <div class="modal-countdown-number marginLeft10"></div>
            </div>
            <p>
              <router-link
                :to="{ name: 'tests.index' }"
                tag="button"
                class="btn btn-primary"
                >Return to Dashboard</router-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import KrAuth from "../../../../components/auth/auth";
export default {
  data() {
    let auth = new KrAuth();
    return {
      auth: auth,
      component_done_loading: false,
      test: {},
      display_test_proper: false,
      is_timer_shown: false,
      accessibility: {
        testSubmissionBtnOption: false,
      },
      componentElement: "",
      sideBarClosed: false,
      sideBarElement: "",
    };
  },
  mounted() {
    var that = this;
    if (["tests.proper", "tests.preview.rat"].includes(this.$route.name)) {
      Events.listen("trigger-test-restart", function(o) {
        that.fetchTest().then(function(response) {
          Vue.set(that, "test", response.data.data);
          Events.fire("test-restarted");
        });
      });
      this.fetchTest().then(function(response) {
        that.test = response.data.data;
        if (!that.test.questions) {
          that.test.questions = [];
        }
        //tag test as preview
        if (that.$route.name == "tests.preview.rat") {
          that.test._isPreview = true;
        }
        if (
          ["Lapsed", "Expired"].includes(that.auth.user().status) &&
          that.auth.user().account.paymentMethod == "Student-Paid" &&
          !that.isTestCompleted(that.test)
        ) {
          that.$router.push({ name: "errors.403" });
        }
        that.component_done_loading = true;
        /*if(that.test.presentationMode){
						that.$notify({
		                    group: 'form',
		                    type:'success',
		                    title: 'Success',
		                    text: 'You will be redirected to discussion screen'
		                });
						that.$router.push({name:'tests.discussion',params:{id:that.$route.params.id}});
					}*/

        var toUpperCase = that.test.type.toUpperCase();
        document.title = `${that.test.name} | ${toUpperCase} | InteDashboard | TBL Makes Teams Work`;
      });
    } else if (this.$route.name == "teachers.tests.preview.rat") {
      this.fetchActivity().then(function(response) {
        that.test = response.data.data;
        that.test._isPreview = true;
        that.test._isTeacherPreview = true;
        that.test.status = "ongoing";
        that.test.myProgression = { userTestStatus: "started" };
        if (that.test.type == "iratntrat") {
          if (that.$route.query.type) {
            that.processPreviewTestType(that.$route.query.type);
          } else {
            that.openPreviewChooseTestTypeModal();
          }
          return;
        } else if (that.test.type == "irat") {
          that.test.settings = that.test.settings.irat;
          that.component_done_loading = true;
        } else if (that.test.type == "trat") {
          that.test.settings = that.test.settings.trat;
          that.component_done_loading = true;
        } else if (that.test.type == "application") {
          that.test.settings = that.test.settings.application;
          that.component_done_loading = true;
        }
        if (["irat", "trat", "application"]) {
          if (!_.isArray(_.get(that.test, "settings.attachments"))) {
            if (!that.test.settings) {
              that.test.settings = {};
            }
            that.test.settings.hasTimeLimit = false;
            that.test.settings.attachments = [];
          }
        }

        var toUpperCase = that.test.type.toUpperCase();
        document.title = `${that.test.name} | ${toUpperCase} | InteDashboard | TBL Makes Teams Work`;
      });
    }

    $(".test > .left_col").addClass("d-none");
  },
  updated() {
    var that = this;
    this.$nextTick(() => {
      if (that.$refs.topbarRef) {
        that.componentElement = that.$refs.topbarRef.$el;
      }
      if (that.$refs.sideBarRef) {
        that.sideBarElement = this.$refs.sideBarRef.$el;
      }
    });
  },
  created() {
    var that = this;
    $("body")
      .addClass("test")
      .removeClass("nav-sm")
      .addClass("nav-none");

    Events.listen("submit-test", function(data) {
      $("#test_confirm_modal").modal("show");
    });

    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    isTestCompleted(test) {
      if (
        ["completed", "ended"].includes(test.status) ||
        ["finished", "incomplete"].includes(test.myProgression.userTestStatus)
      ) {
        return true;
      }
      return false;
    },
    submitConfirmAccessibility(event) {
      var that = this;
      var test_submit_modal_buttons = $(
        "#test_confirm_modal .buttonGroup button"
      );
      switch (event.srcKey) {
        case "test":
          $("#test_confirm_modal").modal("toggle");
          break;
        case "left":
        case "right":
          if (!($("#test_confirm_modal").data("bs.modal") || {}).isShown) {
            return;
          }
          let bias = 0;
          if (that.accessibility.testSubmissionBtnOption === false) {
            that.accessibility.testSubmissionBtnOption = 0;
          } else if (event.srcKey == "left") {
            bias = -1;
          } else if (event.srcKey == "right") {
            bias = 1;
          }
          that.accessibility.testSubmissionBtnOption += bias;
          for (var i = 0; i < test_submit_modal_buttons.length; i++) {
            if (
              i ===
              Math.abs(
                that.accessibility.testSubmissionBtnOption %
                  test_submit_modal_buttons.length
              )
            ) {
              $(test_submit_modal_buttons[i]).addClass("selected");
            } else {
              $(test_submit_modal_buttons[i]).removeClass("selected");
            }
          }
          break;
        case "enter":
          if (!($("#test_confirm_modal").data("bs.modal") || {}).isShown) {
            return;
          }
          for (var i = 0; i < test_submit_modal_buttons.length; i++) {
            if ($(test_submit_modal_buttons[i]).hasClass("selected")) {
              $(test_submit_modal_buttons[i]).click();
            }
          }
          break;
      }
    },
    openPreviewChooseTestTypeModal() {
      $("#previewChooseTestTypeModal").modal("show");
    },
    processPreviewTestType(type) {
      if (type == "irat") {
        this.test.type = "irat";
        this.test.settings = this.test.settings.irat;
      }
      if (type == "trat") {
        this.test.type = "trat";
        this.test.settings = this.test.settings.trat;
      }

      if (!_.isArray(_.get(this.test, "settings.attachments"))) {
        if (!this.test.settings) {
          this.test.settings = {};
        }
        this.test.settings.hasTimeLimit = false;
        this.test.settings.attachments = [];
      }
      this.component_done_loading = true;
    },
    processTimerShown(isShown) {
      this.is_timer_shown = isShown;
    },
    submitTest() {
      var that = this;
      //var instance = axios.create({baseURL:''});
      //instance.post(process.env.VUE_APP_LOG_URL,{cluster:process.env.VUE_APP_APP_ENV,label:'submitTest',data:{userUuid:this.auth.user().uuid,testUuid:this.test.testUuid,userPlacementTestUuid:this.test.uuid}});
      $("#redirectingModal").modal("show");
      that.test._isSubmitting = true;
      axios
        .put("student/tests/" + that.test.uuid + "/submit")
        .then((response) => {
          window.setTimeout(function() {
            $("#redirectingModal").modal("hide");
            if (
              that.test.type == "trat" &&
              _.get(that, "test.settings.allowTeamClarifications")
            ) {
              that.$router.push({
                name: "tests.clarification",
                params: { id: that.test.uuid },
              });
            } else {
              that.$router.push({ name: "tests.index" });
            }
          }, 3000);
        });
    },
    processDisplayTestProper(stopDisplay) {
      if (!this.test.isPublished) {
        this.display_test_proper = true;
      } else {
        this.display_test_proper = !stopDisplay;
      }
    },
    fetchActivity() {
      return axios.get("activities/" + this.$route.params.id);
    },
    fetchTest() {
      return axios.get("student/tests/" + this.$route.params.id);
    },
    handleButtonClicked() {
      var that = this;

      $(".statusBar").toggleClass("sidebar--Collapse");
      $(".main").toggleClass("main--slide");
      $("#toggleIcon").toggleClass("rotate");
      this.sideBarClosed = !this.sideBarClosed;
      window.setTimeout(function() {
        $(".main").css("margin-left", that.sideBarElement.clientWidth + "px");
        $(".main").css(
          "width",
          "calc(100% - " + that.sideBarElement.clientWidth + "px)"
        );
      }, 500);
    },
    handleResize() {
      $(".test_content").css(
        "padding-top",
        this.componentElement.offsetHeight + "px"
      );
      $(".main").css("margin-left", this.sideBarElement.clientWidth + "px");
      $(".main").css(
        "width",
        "calc(100% - " + this.sideBarElement.clientWidth + "px)"
      );
    },
  },
  components: {
    "stopping-div": require(`./partials/stopping-div.vue`).default,
    "test-progression": require(`./partials/progression.vue`).default,
    "test-topbar": require(`./partials/topbar.vue`).default,
    "test-sidebar": require(`./partials/sidebar.vue`).default,
    "question-groups": require(`./partials/questions/question-groups.vue`)
      .default,
    "question-pagination-container": require(`./partials/question-pagination-container.vue`)
      .default,
    "team-leadership": require(`./partials/team-leadership.vue`).default,
  },
  beforeDestroy() {
    if ($(window).width() > 991) {
      $("body")
        .removeClass("test")
        .addClass("nav-sm")
        .removeClass("nav-none");
    } else {
      $("body")
        .removeClass("test")
        .removeClass("nav-sm")
        .addClass("nav-none");
    }
    Events.off("changed-test");
    Events.off("submit-test");
    //from mixin.
    Events.off("current-question-changed");

    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    computedPaddingTop() {
      var that = this;
      return that.componentElement.offsetHeight + "px";
    },
    computedMarginLeft() {
      var that = this;
      if (window.innerWidth >= 992) {
        return that.sideBarElement.clientWidth + "px";
      }

      return false;
    },
    notMobile() {
      if (window.innerWidth >= 992) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style scoped lang="scss">
#test_confirm_modal .modal-body .message {
  text-align: center;
}
#test_confirm_modal .modal-body .message .fa {
  font-size: 40px;
  color: #e69618;
}
.individual {
  padding: 91px 25px 95px !important;
}
.group {
  padding: 91px 25px 95px !important;
}

@media (min-width: 992px) {
  .timer.individual,
  .timer.group {
    padding: 130px 25px 95px !important;
  }
}

@media (max-width: 991px) {
  .timer.individual,
  .timer.group {
    padding: 103px 25px 95px !important;
  }

  .test .right-container {
    padding: 105px 25px 73px 25px !important;
  }
}
#previewChooseTestTypeModal .modal-body .row:last-child {
  margin-top: 30px;
}

#previewChooseTestTypeModal .modal-body .row .col-md-6 {
  padding-right: 10px;
  padding-left: 0;
}
#previewChooseTestTypeModal .modal-body .row .col-md-6:last-child {
  padding-left: 10px;
  padding-right: 0;
}

.print {
  display: none;
}
@media print {
  .print {
    display: block;
  }
}

.modal-countdown-number::after {
  content: "Redirect";
  width: 1ch;
  animation: countdown 3s step-end infinite;
}

.modal-countdown-number::after {
  animation-duration: 3s;
}

@keyframes countdown {
  /*0% {
    content: "10s";
  }
  10% {
    content: "9s";
  }
  20% {
    content: "8s";
  }
  30% {
    content: "7s";
  }
  40% {
    content: "6s";
  }
  0% {
    content: "5s";
  }
  20% {
    content: "4s";
  }*/
  0% {
    content: "3s";
  }
  33% {
    content: "2s";
  }
  67% {
    content: "1s";
  }
  100% {
    content: "0";
  }
}

.new-side-bar {
  display: flex;

  .main {
    -moz-transition: margin-left 0.55s ease-out;
    -o-transition: margin-left 0.55s ease-out;
    -webkit-transition: margin-left 0.55s ease-out;
    transition: margin-left 0.55s ease-out;
  }

  .main--slide {
    -moz-transition: margin-left 0.6s ease-out;
    -o-transition: margin-left 0.6s ease-out;
    -webkit-transition: margin-left 0.6s ease-out;
    transition: margin-left 0.6s ease-out;
  }
}

@media (max-width: 991px) {
  .new-side-bar {
    .main,
    .main--slide {
      margin-left: 0;
      width: 100%;
    }
  }
}
</style>
